import React from 'react';
import styles from './CriteriaFilterCard.module.scss';
import cn from 'classnames';
import { CardDesign } from '../../../../../../components/CardDesign';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as CriteriaIcon } from '../../../../../../resource/CriteriaIcon.svg';
import FilterField from '../../../../shared/ui/FilterField/FilterField';
import { Select } from 'antd';
import useAccessPermitType from '../../../../shared/api/useAccessPermitType';
import usePermitStatusesQuery from '../../../../shared/api/usePermitStatusesQuery';
import { countValues } from '../../lib/countValues';
import { applyPermitFilter } from '../../../../shared/store/action';
import {
  SET_DATE_RANGE_FIELD_PERMIT_FILTER,
  SET_STATUS_ID_PERMIT_FILTER,
  SET_TYPE_ID_PERMIT_FILTER,
} from '../../../../shared/store/types';
import { multiSelectTagProps } from '../../lib/multiSelectTagProps';

const CriteriaFilterCard = () => {
  const dispatch = useDispatch();

  const { permitStatusIds, permitTypeId, dateRangeField } = useSelector(
    (state) => state.permitsFilterStore
  );

  const { data: permitTypes = [], isFetching: isFetchingTypes } =
    useAccessPermitType();
  const { data: permitStatus = [], isFetching: isFetchingStatus } =
    usePermitStatusesQuery();

  const makeChangeHandler = (actionType) => (value) => {
    dispatch(applyPermitFilter(actionType)(value));
  };

  const handleChangeType = (value) => {
    makeChangeHandler(SET_TYPE_ID_PERMIT_FILTER)(value);

    if (dateRangeField === 3) {
      makeChangeHandler(SET_DATE_RANGE_FIELD_PERMIT_FILTER)(1);
    }
  };

  const handleChangeStatus = (value) => {
    makeChangeHandler(SET_STATUS_ID_PERMIT_FILTER)(value);
  };

  return (
    <CardDesign
      classname={cn(styles.card, {
        [styles.active]: countValues(permitStatusIds, permitTypeId),
      })}
    >
      <CardDesign.Header heading="Критерии" icon={<CriteriaIcon />} />

      <CardDesign.Body>
        <div className={styles.content}>
          <FilterField label="Тип" active={!!permitTypeId}>
            <Select
              defaultActiveFirstOption={false}
              allowClear={true}
              placeholder="Выбор"
              notFoundContent="нет данных"
              value={permitTypeId}
              onChange={handleChangeType}
              optionFilterProp="searchtext"
              disabled={isFetchingTypes}
              loading={isFetchingTypes}
            >
              {permitTypes?.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  searchtext={item.name}
                >
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </FilterField>
          <FilterField label="Статус" active={!!countValues(permitStatusIds)}>
            <Select
              defaultActiveFirstOption={false}
              allowClear={true}
              placeholder="Выбор"
              notFoundContent="нет данных"
              value={permitStatusIds}
              onChange={handleChangeStatus}
              optionFilterProp="searchtext"
              disabled={isFetchingStatus}
              loading={isFetchingStatus}
              mode="multiple"
              {...multiSelectTagProps}
            >
              {permitStatus?.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  searchtext={item.name}
                >
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </FilterField>
        </div>
      </CardDesign.Body>
    </CardDesign>
  );
};

export default CriteriaFilterCard;
